import React from 'react';

import Icon from '../Icon/Icon';

import arrowUpIcon from '../../../../assets/arrow_up.svg';

interface SortIconProps {
  reversed?: boolean;
  visible?: boolean;

  onClick(): void;
}

const SortIcon = ({ reversed, visible, onClick }: SortIconProps) => (
  <Icon
    dark
    alt="sort"
    src={arrowUpIcon}
    onClick={onClick}
    containerStyle={{
      paddingTop: 0,
      marginLeft: '5px',
      visibility: visible ? 'visible' : 'hidden',
      transform: reversed ? 'rotate(180deg)' : 'none',
    }}
  />
);

SortIcon.defaultProps = {
  reversed: false,
  visible: true,
};

export default SortIcon;
